import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { ApplicationFormTemplateState } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';

export const actions: ActionTree<ApplicationFormTemplateState, RootState> = {
    /**
     * 申請書テンプレート一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @returns {Promise<void>}
     */
    async search({ dispatch, commit }, { pageNumber, perPage, sort } = {}) {
        const payload = {
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        try {
            commit(types.SEARCH_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.ApplicationFormTemplate.INDEX,
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SEARCH_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SEARCH_FAILURE, resData.errors[0]);
        }
    },

    /**
     * 申請書テンプレート詳細部分取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {number} id 申請書テンプレートID
     * @param {boolean} base 基本情報を取得するかどうか
     * @param {boolean} customize_field 追加情報を取得するかどうか
     * @param {boolean} business 業務情報を取得するかどうか
     * @param {boolean} worker 作業者情報を取得するかどうか
     * @param {boolean} workflow ワークフロー情報を取得するかどうか
     * @returns {Promise<void>}
     */
    async show({ dispatch, commit }, { id, base, customize_field, business, worker, workflow } = {}) {
        try {
            commit(types.SHOW_START);
            const fetch_items = [
                {
                    is_fetch: base,
                    url: ApiUrl.ApplicationFormTemplate.BASE.replace(':id', id.toString()),
                    commit_type: types.SHOW_RECEIVE_BASE,
                },
                {
                    is_fetch: customize_field,
                    url: ApiUrl.ApplicationFormTemplate.CUSTOMIZE_FIELD.replace(':id', id.toString()),
                    commit_type: types.SHOW_RECEIVE_CUSTOMIZE_FIELD,
                },
                {
                    is_fetch: business,
                    url: ApiUrl.ApplicationFormTemplate.BUSINESS.replace(':id', id.toString()),
                    commit_type: types.SHOW_RECEIVE_BUSINESS,
                },
                {
                    is_fetch: worker,
                    url: ApiUrl.ApplicationFormTemplate.WORKER.replace(':id', id.toString()),
                    commit_type: types.SHOW_RECEIVE_WORKER,
                },
                {
                    is_fetch: workflow,
                    url: ApiUrl.ApplicationFormTemplate.WORKFLOW.replace(':id', id.toString()),
                    commit_type: types.SHOW_RECEIVE_WORKFLOW,
                },
            ];
            for (const entry of fetch_items) {
                if (entry.is_fetch) {
                    const resData = await dispatch(
                        'auth/api',
                        {
                            method: 'get',
                            url: entry.url,
                        },
                        { root: true }
                    );
                    if (isHappenedOtherPartyError(resData)) {
                        // システムエラー・予期せぬエラー時
                        commit(types.FATAL_FAILURE);
                        return;
                    } else {
                        // 成功時
                        commit(entry.commit_type, resData);
                    }
                }
            }
            // 全て成功時
            commit(types.SHOW_SUCCESS);
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SHOW_FAILURE, resData.errors[0]);
        }
    },

    /**
     * 申請書テンプレート件数取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async count({ dispatch, commit }) {
        try {
            commit(types.COUNT_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.ApplicationFormTemplate.COUNT,
                },
                { root: true }
            );

            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.COUNT_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.COUNT_FAILURE, resData.errors[0]);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ON_ROUTE);
    },
};
